import { Component, OnDestroy, OnInit } from '@angular/core';
import { ProductSearchPage, ProductSearchService, TranslatePipe } from '@spartacus/core';
import { PageLayoutService, ProductListComponentService, ViewConfig, ViewModes, PaginationComponent } from '@spartacus/storefront';
import { Observable, Subscription } from 'rxjs';
import { take, tap } from 'rxjs/operators';

import { ProductViewModeService } from './../../services/product-view-mode-service';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';
import { Router } from '@angular/router';
import { KnBrProductGridItemComponent } from './kn-br-product-grid-item/kn-br-product-grid-item.component';
import { KnBrProductListItemComponent } from './kn-br-product-list-item/kn-br-product-list-item.component';
import { KnBrProductScrollComponent } from './kn-br-product-scroll/kn-br-product-scroll.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'kn-br-product-list',
    templateUrl: './kn-br-product-list.component.html',
    styleUrls: ['./kn-br-product-list.component.scss'],
    imports: [PaginationComponent, KnBrProductGridItemComponent, KnBrProductListItemComponent, KnBrProductScrollComponent, AsyncPipe, TranslatePipe]
})
export class KnBrProductListComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();
  isInfiniteScroll: boolean;
  model$: Observable<ProductSearchPage> = this.productListComponentService.model$;
  viewMode$ = this.viewModeService.getViewMode$();
  ViewModes = ViewModes;
  constructor(
    protected pageLayoutService: PageLayoutService,
    protected productListComponentService: ProductListComponentService,
    public scrollConfig: ViewConfig,
    protected viewModeService: ProductViewModeService,
    protected productSearchService: ProductSearchService,
    private knBrCommonService: KnBrCommonService,
    protected router: Router
  ) {
    if(router.url.includes('/search/')){
      this.knBrCommonService.setSpinner(true);
    }
  }
  ngOnInit(): void {
    this.isInfiniteScroll = this.scrollConfig.view.infiniteScroll.active;
    // this.isInfiniteScroll = true;
    this.viewModeService.setViewMode(ViewModes.Grid);
    this.model$.subscribe((data) => {
      console.log("logging model data", data);
      this.knBrCommonService.setSpinner(false)});
  }
  ngOnDestroy(): void {
    this.productSearchService.getResults();
    this.productSearchService.clearResults();
    this.subscription.unsubscribe();
  }
}
